/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_Li2Inputs */

const tr_onbilgi_s2_li2 = /** @type {(inputs: Onbilgi_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura entegrasyonu (QNB eSolutions)`)
};

const en_onbilgi_s2_li2 = /** @type {(inputs: Onbilgi_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura integration (QNB eSolutions)`)
};

const de_onbilgi_s2_li2 = /** @type {(inputs: Onbilgi_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura-Integration (QNB eSolutions)`)
};

const ru_onbilgi_s2_li2 = /** @type {(inputs: Onbilgi_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграция e-Fatura (QNB eSolutions)`)
};

/**
* | output |
* | --- |
* | "e-Fatura integration (QNB eSolutions)" |
*
* @param {Onbilgi_S2_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_li2 = /** @type {((inputs?: Onbilgi_S2_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_li2(inputs)
	if (locale === "de") return de_onbilgi_s2_li2(inputs)
	if (locale === "ru") return ru_onbilgi_s2_li2(inputs)
	return tr_onbilgi_s2_li2(inputs)
});